// extracted by mini-css-extract-plugin
export default {"projectCardContainer":"projectCardContainer___per9V"};